const items = [
    "LAYANAN RESPONSIF",
    "AMAN & TERPERCAYA",
    "24 JAM NONSTOP",
    "WHATSAPP & TELEGRAM RESMI",
    "BANTUAN PUSATCUAN",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {items.map((item, i) => (
            <span key={i} className="flex items-center">
                <span className="font-serif-display px-8 text-2xl font-light italic text-[#D4AF37]/40 sm:text-3xl">
                    {item}
                </span>
                <span className="text-[#D4AF37]/25">✦</span>
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        aria-hidden="true"
        className="overflow-hidden border-y border-[#D4AF37]/10 py-8"
    >
        <div className="marquee-track">
            <Row />
            <Row />
        </div>
    </div>
);
